import { jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.5 6.45C2.5 2.853 5.76 1.5 8 1.5s5.5 1.478 5.5 4.95C13.5 9.922 8 14.5 8 14.5s-5.5-4.454-5.5-8.05Zm7.145 4.313c.723-.835 1.295-1.623 1.697-2.34.43-.77.658-1.452.658-1.973 0-1.072-.437-1.936-1.297-2.568-.886-.65-1.958-.881-2.703-.881-.745 0-1.85.222-2.714.844C4.421 4.466 4 5.319 4 6.45c0 .624.305 2.02 2.349 4.353a24.081 24.081 0 0 0 1.64 1.686 25.59 25.59 0 0 0 1.656-1.726ZM7.09 5.385l1.437-.381.381 1.437-1.437.381-.381-1.437Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as Address
};
